import type { Technique } from '../types';
import { MOSS_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type MossState } from './render';

export const moss: Technique<MossState> = {
  id: 'moss',
  name: 'Moos & Korallen',
  category: 'growth',
  description: 'Zellen wachsen an der Textkontur entlang und verdicken sie organisch.',
  params: MOSS_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
